import { useEffect, useRef } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    Box,
    Avatar,
    Stack,
} from '@mui/material';
import { X } from 'lucide-react';
import { formatDate } from '../../utilities/date';
import { Chat } from './chat';

interface ChatModalProps {
    chat: Chat;
    onClose: () => void;
}

export default function ChatModal({ chat, onClose }: ChatModalProps) {
    const dialogContentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (chat) {
            setTimeout(() => {
                if(dialogContentRef.current){
                    dialogContentRef.current.scrollTop = dialogContentRef.current.scrollHeight;
                }
            }, 100);
        }
    }, [chat]);

    return (
        <Dialog
            open={true}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                            <Avatar sx={{ bgcolor: 'primary.main', width: 40, height: 40 }}>
                                {chat.nome_cliente_message.charAt(0).toUpperCase()}
                            </Avatar>
                            <Typography variant="h6">{chat.nome_cliente_message}</Typography>
                        </Box>
                        <Stack spacing={0.5} sx={{ ml: 7 }}>
                            <Typography variant="body2" color="text.secondary">{chat.whatsapp_cliente}</Typography>
                        </Stack>
                    </Box>
                    <IconButton onClick={onClose} size="small">
                        <X />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent sx={{ p: 3 }} ref={dialogContentRef} >
                <Stack spacing={2}>
                    {chat.messages.map((message) => (
                        <Box key={message.id_whatsapp_message}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                <Typography variant="subtitle2">{message.causa_processo_message} | {message.status_processo_message}</Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {formatDate(message.message_at, "brH")}
                                </Typography>
                            </Box>
                            <Box sx={{
                                bgcolor: 'grey.100',
                                p: 2,
                                borderRadius: 1
                            }}>
                                <Typography variant="body1">{message.message}</Typography>
                            </Box>
                        </Box>
                    ))}
                </Stack>
            </DialogContent>
        </Dialog>
    );
}